import { clinicInfo_LABELS } from "../../../../constants/labels/ClinicInfo";
import Info from "../../../shared/SVG/Info";
import { ReactComponent as Download } from "../../../../assets/svg/Download.svg";
import { ReactComponent as Settings } from "../../../../assets/svg/Settings.svg";
import { ReactComponent as NoLogo } from "../../../../assets/svg/noLogo.svg";
import { ReactComponent as DeleteLogo } from "../../../../assets/svg/DeleteFile.svg";

import "./ClinicInfo.scss";
import { Button } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import {
  useLazyDeleteClinicLogoQuery,
  useLazyGetManageSubscriptionUrlQuery,
  useLazyUpdateClinicUserDetailsQuery,
} from "../../../../services/rtkQueryServices/clinicService";
import FileUpload from "../../../shared/Input/FileUpload";
import Modal from "../../../shared/Modal/Modal";
import { errorMessages } from "../../../../constants/errorMessages";
import Slider from "../../../shared/Widget/Slider/Slider";
import { BpSiteIdVerificationHandler } from "./BpSiteIdVerificationHandler";
import ConfirmationDialog from "../../../shared/ConfirmationDialog/ConfirmationDialog";
export function ClinicInfo(props: any) {
  const [updateClinicUserDetails] = useLazyUpdateClinicUserDetailsQuery();
  const [deleteClinicLogo] = useLazyDeleteClinicLogoQuery();
  const [manageSubscriptionUrl] = useLazyGetManageSubscriptionUrlQuery();
  const [clinicLogoUrl, setClinicLogoUrl] = useState<any>();
  const [clinicLogo, setClinicLogo] = useState<any>();
  const [showSubscription, setShowSubscription] = useState<boolean>(false);
  const [chargebeeUrl, setChargebeeUrl] = useState<string>("");
  const [fileUploadErrors, setFileUploadErrors] = useState<any>();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isCustomerDeleted, setIsCustomerDeleted] = useState<boolean>(false);
  const isBpSiteIdVerified = useMemo(() => {
    return props.isBpSiteIdVerified;
  }, [props.isBpSiteIdVerified]);
  const isSubscriptionActive = useMemo(() => {
    return props.isSubscriptionActive;
  }, [props.isSubscriptionActive]);
  const [openBpSiteIdHandler, setOpenBpSiteIdHandler] =
    useState<boolean>(false);
  const refetchDetails = useMemo(() => {
    return props?.refetchDetails;
  }, [props?.refetchDetails]);

  useEffect(() => {
    if (props?.error) {
      setErrorMessage(props?.error);
    }
  }, [props.error]);
  const handleError = () => {
    setErrorMessage("");
  };
  useEffect(() => {
    if (errorMessage) {
      document.body.addEventListener("click", handleError);
    }
    return () => {
      document.body.removeEventListener("click", handleError);
    };
  }, [errorMessage]);
  const clinicUserData = useMemo(() => {
    return props?.clinicUserData;
  }, [props.clinicUserData]);
  const validateFileUpload = (file: any) => {
    let supportedTypes = process.env.REACT_APP_EVO_LOGO_SUPPORTED_TYPES?.split(
      ","
    ) || ["image/png", "image/jpg", "image/jpeg"];
    let error = null;
    if (file && supportedTypes.indexOf(file.type) < 0) {
      error = `Upload only JPEG/JPG/PNG files.`;
    } else if (file && file.size >= 30000) {
      error = "File size must be less than 30KB.";
    } else if (file && file.size <= 0) {
      error = "Empty files cannot be uploaded.";
    }
    return error;
  };
  return (
    <>
      <div className="clinic-info-header d-flex align-items-center">
        <div>Clinic Details</div>
        <div className="error-message error flex-grow-1 text-align-center">
          {errorMessage}
        </div>
      </div>
      <div className="clinic-info-wrapper d-flex">
        <div className="clinic-logo-wrapper d-flex align-items-center">
          <div>
            {clinicUserData?.clinicLogoUrl ? (
              <img
                src={clinicUserData?.clinicLogoUrl}
                className="clinic-logo"
              ></img>
            ) : (
              <div className="no-clinic-logo d-flex flex-column justify-content-center align-items-center">
                <NoLogo />
                <div className="no-logo-info">No Logo Available</div>
              </div>
            )}
            <div className="logo-info pt-3">
              {fileUploadErrors ? (
                <div className="error-message">{fileUploadErrors}</div>
              ) : (
                <>*Upload your Clinic Logo</>
              )}
            </div>
          </div>
          <div className="d-flex flex-column align-items-center gap-1">
            <span className="help-icon ">
              <Info width={24} height={24} fillColor={"var(--label-color)"} />
              <div className="help-info">
                {isBpSiteIdVerified && isSubscriptionActive ? (
                  <p>
                    Accepted file formats PNG, JPEG, JPG.
                    <br />
                    Max size - 30KB.
                  </p>
                ) : !isSubscriptionActive ? (
                  <p>Renew your subscription to upload clinic logo</p>
                ) : (
                  !isBpSiteIdVerified && (
                    <p>Verify your BP Site ID to upload clinic logo</p>
                  )
                )}
              </div>
            </span>
            <Button disabled={!isBpSiteIdVerified || !isSubscriptionActive}>
              <FileUpload
                name="Logo"
                accept={process.env.REACT_APP_EVO_LOGO_SUPPORTED_TYPES}
                fileUrl={""}
                onClear={() => {}}
                onInput={(e: any) => {
                  setFileUploadErrors("");
                  let image = (e.target as any).files[0];
                  let reader = new FileReader();
                  reader.onload = function () {
                    let base64String = (reader?.result as string)
                      .replace("data:", "")
                      ?.replace(/^.+,/, "");
                    setClinicLogoUrl(image?.name);
                    setClinicLogo({
                      fileData: base64String,
                      fileExtension: image?.name?.split(".")[1],
                    });
                    const error = validateFileUpload(image);
                    setFileUploadErrors(error);
                    if (!error) {
                      updateClinicUserDetails({
                        clinicLogoUrl: image?.name,
                        clinicLogo: {
                          fileData: base64String,
                          fileExtension: image?.name?.split(".")[1],
                        },
                      }).then((res) => {
                        if (res.isSuccess) {
                          props.refetchClinicDetails();
                        }
                      });
                    }
                  };

                  reader.readAsDataURL(image);
                }}
                required
                //infoIconProps={infoIconProps}
                labelHelpText={
                  isBpSiteIdVerified && isSubscriptionActive ? (
                    <p>
                      Accepted file formats PNG, JPEG, JPG.
                      <br />
                      Max. size limit 30KB
                    </p>
                  ) : !isSubscriptionActive ? (
                    <p>Renew your subscription to upload clinic logo</p>
                  ) : (
                    !isBpSiteIdVerified && (
                      <p>Verify your BP Site ID to upload clinic logo</p>
                    )
                  )
                }
              />
            </Button>
            {clinicUserData?.clinicLogoUrl &&
              isBpSiteIdVerified &&
              isSubscriptionActive && (
                <>
                  <DeleteLogo
                    className="cursor-pointer"
                    onClick={() => {
                      setFileUploadErrors("");
                      deleteClinicLogo({}).then((res) => {
                        if (res.isSuccess) {
                          props.refetchClinicDetails();
                        }
                      });
                    }}
                  />
                </>
              )}
          </div>
        </div>
        {/* <div className="v-line"></div> */}
        <div className="clinic-details-wrapper d-flex flex-column flex-grow-1">
          <div className="clinic-details d-flex justify-content-center align-items-center">
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">{clinicInfo_LABELS.clinicName}</div>
              <div className="clinic-info">{clinicUserData?.clinicName}</div>
            </div>
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">{clinicInfo_LABELS.user}</div>
              <div className="clinic-info">
                {clinicUserData?.firstName} {clinicUserData?.lastName}
              </div>
            </div>
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">{clinicInfo_LABELS.emailId}</div>
              <div className="clinic-info">{clinicUserData?.userEmail}</div>
            </div>
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">{clinicInfo_LABELS.bpSiteId}</div>
              {isBpSiteIdVerified ? (
                <div className="clinic-info">{clinicUserData?.bpSiteId}</div>
              ) : (
                isSubscriptionActive &&
                isBpSiteIdVerified !== null && (
                  <div>
                    <Button
                      variant="contained"
                      onClick={() => {
                        setOpenBpSiteIdHandler(true);
                      }}
                    >
                      Verify BP Site ID
                    </Button>
                  </div>
                )
              )}
            </div>
          </div>
          <div className="clinic-details d-flex justify-content-center align-items-center">
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">{clinicInfo_LABELS.status}</div>
              <div
                className={`clinic-info ${
                  isSubscriptionActive !== null &&
                  (isSubscriptionActive ? "Active" : "InActive")
                }`}
              >
                {isSubscriptionActive !== null &&
                  (isSubscriptionActive ? "Active" : "InActive")}
              </div>
            </div>
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">
                {clinicInfo_LABELS.totalLicenceKeys}
              </div>
              <div className="clinic-info">{clinicUserData?.licenseCount}</div>
            </div>
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">
                {clinicInfo_LABELS.noOfUsersAdded}
              </div>
              <div className="clinic-info">{clinicUserData?.noOfUsers}</div>
            </div>
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">
                {clinicInfo_LABELS.clinicAddress}
              </div>
              <div className="clinic-info">{clinicUserData?.clinicAddress}</div>
            </div>
          </div>
        </div>
        <div className="manage-options d-flex">
          <Button
            className="clinic-button download-app d-flex align-items-center"
            disabled={!isBpSiteIdVerified || !isSubscriptionActive}
          >
            <a href={process.env.REACT_APP_DOWNLOAD_EVO_APP} download>
              <Download />
              <span className="px-2">Download EVO App</span>
            </a>
          </Button>
          <Button
            className="clinic-button manage-subscription"
            onClick={() => {
              manageSubscriptionUrl({}).then((res) => {
                if (res.isSuccess) {
                  setChargebeeUrl(res.data?.data?.accessUrl);
                  setShowSubscription(true);
                } else if (res.isError) {
                  setIsCustomerDeleted(true);
                }
              });
            }}
          >
            <Settings width={20} height={20} className="pb-1" />
            <span className="px-1">Manage Subscription</span>
          </Button>
        </div>
      </div>
      <Modal
        isOpen={showSubscription}
        headerBg="var(--white)"
        onClose={() => {
          setShowSubscription(false);
          window.location.reload();
        }}
        title=""
        closeOnOverLayClick={false}
        modalWidth="416px"
      >
        {showSubscription && (
          <iframe src={chargebeeUrl} height="530px" width="400px" />
        )}
      </Modal>
      <ConfirmationDialog
        open={isCustomerDeleted}
        contentBody={
          <>
            <div className="text-align-center alert-error-message">Alert!!</div>
            <div className="pt-5">
              <div className="text-align-center">
                Your subscription has expired.
              </div>
              <div className="text-align-center">
                Please contact{" "}
                <span
                  className="link"
                  onClick={() => {
                    window.open(process.env.REACT_APP_SUPPORT_LINK);
                  }}
                >
                  support
                </span>{" "}
                to renew your subscription.
              </div>
            </div>
          </>
        }
        onOk={() => {
          setIsCustomerDeleted(false);
        }}
        okButtonClassName=""
        onCancel={() => {
          setIsCustomerDeleted(false);
        }}
      />
      <Slider
        isOpen={openBpSiteIdHandler}
        onClose={() => {
          setOpenBpSiteIdHandler(false);
        }}
        title={"Validate BP Site ID"}
      >
        <BpSiteIdVerificationHandler
          onClose={() => {
            setOpenBpSiteIdHandler(false);
            window.location.reload();
          }}
        />
      </Slider>
    </>
  );
}
